var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73339 15.0334C6.57784 15.0334 6.42806 15.0054 6.28406 14.9494C6.13917 14.8943 6.01117 14.8111 5.90006 14.7L0.333394 9.13337C0.133394 8.93337 0.0387274 8.69426 0.0493941 8.41603C0.0609497 8.1387 0.155616 7.90003 0.333394 7.70003C0.533394 7.50003 0.772505 7.40003 1.05073 7.40003C1.32806 7.40003 1.55562 7.50003 1.73339 7.70003L6.73339 12.7L18.2667 1.1667C18.4445 0.966699 18.6778 0.866699 18.9667 0.866699C19.2556 0.866699 19.489 0.966699 19.6667 1.1667C19.8667 1.3667 19.9667 1.60537 19.9667 1.8827C19.9667 2.16092 19.8667 2.40003 19.6667 2.60003L7.56673 14.7C7.45562 14.8111 7.32806 14.8943 7.18406 14.9494C7.03917 15.0054 6.88895 15.0334 6.73339 15.0334Z",
    fill: "#15A115"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreen);
export default __webpack_public_path__ + "static/media/checkmark-green.8bc2f42f05de8083cf86647a84c5da2e.svg";
export { ForwardRef as ReactComponent };